import { createAction } from 'redux-actions';

export const CHECK_FEATURES = 'FEATURE_DETECTION::CHECK_FEATURES';
export const SET_MODAL_STATE = 'FEATURE_DETECTION::SET_MODAL_STATE';

export const checkFeatures = createAction(CHECK_FEATURES);

export const setModalState = createAction(SET_MODAL_STATE);
